import React, { useState } from "react";
import { Btn } from "./common";
import { useI18n } from "@/lib/i18n";
import { ShieldCheck, X } from "lucide-react";

/* Shared review step for every confirmed write (e-mail send, calendar event).
   The user must SEE exactly what will happen; confirming here is what produces the server-side
   one-time token. Values are rendered as plain text — no markdown/HTML interpretation. */
export const ReviewConfirm = ({ title, rows, body, warning, confirmLabel, onConfirm, onCancel, testid }) => {
  const { tx } = useI18n();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-3"
      role="dialog" aria-modal="true" data-testid={testid || "review-confirm"}>
      <div className="panel w-full max-w-xl max-h-[88vh] overflow-y-auto scrollbar-thin p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <h3 className="label-eyebrow flex items-center gap-2 m-0"><ShieldCheck size={13} className="text-cyan-300" />{title}</h3>
          <button onClick={onCancel} aria-label={tx("Kapat")} data-testid="review-close" className="text-white/50 hover:text-white"><X size={16} /></button>
        </div>
        <dl className="space-y-1.5 mb-3">
          {rows.filter(([, v]) => v !== undefined && v !== null && v !== "").map(([k, v]) => (
            <div key={k} className="flex gap-2 text-sm">
              <dt className="text-white/45 w-28 shrink-0">{k}</dt>
              <dd className="text-white/90 break-words min-w-0">{String(v)}</dd>
            </div>
          ))}
        </dl>
        {body !== undefined && (
          <div className="bg-black/30 border border-cyan-500/15 rounded-lg p-3 mb-3">
            <div className="label-eyebrow mb-1">{tx("Gövde")}</div>
            <pre className="text-xs text-white/85 whitespace-pre-wrap font-sans max-h-60 overflow-y-auto scrollbar-thin"
              data-testid="review-body">{body || tx("(boş)")}</pre>
          </div>
        )}
        {warning && <div className="text-[0.72rem] text-amber-200/90 mb-3" data-testid="review-warning">{warning}</div>}
        <div className="flex gap-2 justify-end">
          <Btn variant="ghost" onClick={onCancel}>{tx("Vazgeç")}</Btn>
          <Btn onClick={go} disabled={busy} data-testid="review-confirm-btn">{busy ? tx("İşleniyor…") : confirmLabel}</Btn>
        </div>
      </div>
    </div>
  );
};

export default ReviewConfirm;
